angular.module("vgresiduos").directive("generalTopAlerts", function () {
	"use strict";
	return {
		scope: true,
		controller: "generalTopAlertsCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/components/generalTopAlerts/generalTopAlerts_template.html"
	};
});
